import Api from "./Api.service.js";

export const HEALTHY_POLL_INTERVAL_MS = 1 * 60 * 1000;
export const UNHEALTHY_POLL_INTERVAL_MS = 30 * 1000;
export const HEALTH_CHECK_TIMEOUT_MS = 10 * 1000;

export function isProductHealthy(status) {
  return status === "up" || status === "unknown";
}

function isBackendUnreachable(error, response) {
  if (!response) {
    return true;
  }

  const status = response.status;
  return status === 500 || status === 502 || status === 503 || status === 504;
}

function resolveErrorCode(error, response, backendUnreachable) {
  if (backendUnreachable) {
    const status = response && response.status;
    if (status === 502 || status === 503 || status === 504) {
      return status;
    }

    return 500;
  }

  return 503;
}

export async function fetchProductHealth(productKey) {
  try {
    const response = await Api.health({
      timeout: HEALTH_CHECK_TIMEOUT_MS
    });
    const product = response.data && response.data[productKey];

    if (!product || !product.status) {
      return {
        healthy: false,
        errorCode: 500,
        backendUnreachable: true
      };
    }

    if (isProductHealthy(product.status)) {
      return {
        healthy: true,
        errorCode: 0,
        backendUnreachable: false
      };
    }

    return {
      healthy: false,
      errorCode: 503,
      backendUnreachable: false
    };
  } catch (error) {
    const response = error.response;
    const backendUnreachable = isBackendUnreachable(error, response);

    return {
      healthy: false,
      errorCode: resolveErrorCode(error, response, backendUnreachable),
      backendUnreachable
    };
  }
}
